import { render, staticRenderFns } from "./coamaping.vue?vue&type=template&id=d6fe6fd6"
import script from "./coamaping.vue?vue&type=script&lang=js"
export * from "./coamaping.vue?vue&type=script&lang=js"
import style0 from "./coamaping.vue?vue&type=style&index=0&id=d6fe6fd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports